import { useEffect, useState } from 'react'
import { useBahasa } from '../../../app/i18n'
import { useFiturTenant, useSetelanSaya, useUbahSetelanSaya } from '../../../domains/tenancy/api'
// Daftar tujuan datang dari rute yang SAMA dengan layar Buat Konten — kalau layar ini
// punya daftarnya sendiri, keduanya akan menyimpang begitu satu kanal ditambah.
import { useTujuan } from '../../../domains/content/api'
import { hitungGambarPerHari } from '../../../shared/lib/gambar'
import Model from './Model'
import Referensi from './Referensi'
import {
  AreaTeks, Baris, Bendera, Body, Chip, Gagal, Isian, Jadwal, KV, KVBaris, KepalaHalaman,
  Kolom2,
  Memuat, Panel, PenyediaSimpan, Seg, Sub, Tab, Tabel, Tombol, TombolSimpanKepala,
  dariCron, jamDariFrekuensi, useSimpanKepala,
} from '../../../shared/ui'

/**
 * ATUR KONTEN — empat tab, mengikuti `arsip/docs-v2/desain/tenant-admin.html`:
 * Cari bahan · Jadwal terbit · Persetujuan · Model.
 *
 * Sebelum ini ketiganya bertumpuk di satu halaman gulung dan tab "Model" tidak ada sama
 * sekali — model konten tersembunyi di dalam Chatbot, di layar yang sama dengan model
 * balasan chat. Itu menaruh dua keputusan yang tidak sebanding dalam satu daftar: model
 * gambar paling terasa di BIAYA, model caption paling terasa di MUTU.
 *
 * KRITERIA SELESAI TAHAP 4: "Mematikan `scraping` membuat pengaturannya hilang dari
 * backoffice." Ditegakkan di tab "Cari bahan" — isinya tidak dirender kalau fiturnya mati.
 * Tapi ia tidak menghilang DIAM-DIAM: satu kalimat menggantikannya, menyebut sebabnya dan
 * di mana menyalakannya lagi. Pengaturan yang lenyap tanpa penjelasan terbaca sebagai
 * kerusakan, dan orang akan mencarinya di tempat yang salah.
 */
// Sumber yang BENAR-BENAR dipanggil `domains/content/trend.py`. Daftar tulis tangan yang
// menyebut sumber yang tidak ada akan jadi kotak centang yang tidak mengubah apa pun.
const SUMBER = [
  { id: 'serper_news', label: 'Google News' },
  { id: 'reddit', label: 'Reddit' },
]

function BagianScraping({ t, data, simpan, menyimpan }) {
  const [topik, setTopik] = useState('')
  const [jadwal, setJadwal] = useState('')
  const [sumber, setSumber] = useState([])
  const [bahasa, setBahasa] = useState('id')
  const [kedaluwarsa, setKedaluwarsa] = useState(7)
  const [gaya, setGaya] = useState('')

  useEffect(() => {
    if (!data) return
    setTopik((data.scraping_topics ?? []).join(', '))
    setJadwal(data.scraping_schedule ?? '')
    setSumber(data.scraping_sources ?? [])
    setBahasa(data.scraping_language ?? 'id')
    setKedaluwarsa(data.konsep_kedaluwarsa_hari ?? 7)
    setGaya(data.gaya_visual ?? '')
  }, [data])

  // Tab "Cari bahan" sempat TIDAK PUNYA pendaftaran sama sekali: suntingan yang
  // memasangnya tidak kena karena teks jangkarnya sudah berubah, dan `replace` tanpa
  // pemeriksaan diam saja. Akibatnya tombol simpannya mati di tab ini, dan topik yang
  // diketik hilang saat pindah tab.
  useSimpanKepala(() => simpan({
    scraping_topics: topik.split(',').map((x) => x.trim()).filter(Boolean),
    scraping_sources: sumber,
    scraping_language: bahasa,
    scraping_schedule: jadwal.trim() || undefined,
    konsep_kedaluwarsa_hari: Number(kedaluwarsa) || 0,
    gaya_visual: gaya,
  }), { menyimpan })

  return (
    <>
    <Kolom2>
    <Panel judul={t('tk.scrapingJudul')} catatan={t('tk.scrapingCatatan')}>
      <Body>
        <KV>
          <KVBaris label={t('tk.kolTopik')}>
            <Isian
              value={topik}
              placeholder="asuransi kesehatan, klaim asuransi"
              onChange={(e) => setTopik(e.target.value)}
            />
            <Sub>{t('tk.topikCatatan')}</Sub>
          </KVBaris>

          {/* FREKUENSI, BUKAN CRON. `0 9 * * *` menuntut orang tahu urutan lima medan,
              dan satu digit yang meleset menghasilkan jadwal yang sah tapi bukan yang
              dimaksud — tanpa satu pun galat. Cron tetap bentuk simpanannya karena tick
              scraping yang membacanya; yang berubah cuma siapa yang merakitnya. */}
          <KVBaris label={t('tk.kolSumber')}>
            <span className="flex flex-wrap gap-1.5">
              {SUMBER.map((x) => {
                const aktif = sumber.includes(x.id)
                return (
                  <Tombol
                    key={x.id}
                    kecil
                    aria-pressed={aktif}
                    jenis={aktif ? 'utama' : 'sekunder'}
                    onClick={() => setSumber(aktif
                      ? sumber.filter((y) => y !== x.id)
                      : [...sumber, x.id])}
                  >
                    {x.label}
                  </Tombol>
                )
              })}
            </span>
            {/* NOL SUMBER = scraping berjalan dan tidak menemukan apa pun. Backend jatuh
                ke kedua sumber saat daftarnya kosong, jadi mematikan keduanya TIDAK
                mematikan scraping — ia mengembalikannya ke bawaan. Dikatakan, bukan
                dibiarkan orang menyimpulkan sendiri. */}
            <Sub>{sumber.length === 0 ? t('tk.sumberKosong') : t('tk.sumberCatatan')}</Sub>
          </KVBaris>

          <KVBaris label={t('tk.kolBahasa')}>
            <Seg
              nilai={bahasa}
              set={setBahasa}
              daftar={[
                { id: 'id', label: 'Indonesia' },
                { id: 'en', label: 'English' },
                { id: 'ms', label: 'Melayu' },
              ]}
            />
            <Sub>{t('tk.bahasaCatatan')}</Sub>
          </KVBaris>

        </KV>
      </Body>

    </Panel>

    <Panel judul={t('tk.frekuensiJudul')}>
      <Body>
        <Jadwal nilai={jadwal} set={setJadwal} t={t} />

        {/* BERAPA LAMA KONSEP MENUNGGU SEBELUM DIBUANG.
            Ditaruh di panel Frekuensi, bukan panel sendiri: ia jawaban dari pertanyaan
            yang sama — seberapa sering, dan sampai kapan. Tiga slot sehari berarti 66
            konsep sebulan, dan antrean yang isinya ratusan berhenti dibaca siapa pun. */}
        <KV>
          {/* GAYA VISUAL — lapisan KEDUA, dan hanya lapisan kedua.
              Aturan teknis (tanpa teks di gambar, rasio 4:5, hindari klise) dipatok di
              `brain.py` dan TIDAK bisa diatur dari sini: itu bukan selera melainkan
              fakta tentang apa yang model gambar kerjakan dengan buruk. Yang di sini
              selera — palet, jenis ilustrasi, suasana — dan itu beda tiap brand. */}
          <KVBaris label={t('tk.gayaLabel')}>
            <span className="flex flex-col gap-1 w-full">
              <AreaTeks
                baris={3}
                value={gaya}
                maxLength={600}
                placeholder={t('tk.gayaContoh')}
                onChange={(e) => setGaya(e.target.value)}
              />
              <Sub>{t('tk.gayaKet')}</Sub>
            </span>
          </KVBaris>
          <KVBaris label={t('tk.kedaluwarsaLabel')}>
            <span className="flex flex-wrap items-center gap-2">
              <Isian
                type="number"
                min={0}
                max={365}
                className="max-w-[80px] tabular"
                value={Number(kedaluwarsa) || 0}
                onChange={(e) => setKedaluwarsa(
                  Math.max(0, Math.min(365, Number(e.target.value) || 0)))}
              />
              <Sub>
                {Number(kedaluwarsa) > 0
                  ? t('tk.kedaluwarsaKet', { n: Number(kedaluwarsa) })
                  : t('tk.kedaluwarsaMati')}
              </Sub>
            </span>
          </KVBaris>
        </KV>
      </Body>

      {/* PEMBACAAN, bukan pengulangan kontrol. Pengatur di atas menyusun cron; tiga baris
          ini menyebut APA YANG JADI — jam persisnya dan hari mana. Rancangan memuatnya,
          dan sebabnya: orang menyetel "4× sehari" lalu bertanya "jam berapa saja itu",
          dan tanpa baris ini jawabannya cuma ada di cron yang sengaja disembunyikan. */}
      <Body className="border-t border-line">
        <Ringkas jadwal={jadwal} t={t} />
      </Body>

      <Body className="border-t border-line">
        <Sub>{data?.scraping_schedule_label || t('tk.jadwalCatatan')}</Sub>
      </Body>
    </Panel>
    </Kolom2>
    </>
  )
}

const HARI_SINGKAT = ['Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab', 'Min']

/**
 * Apa yang jadi dari jadwal itu: berapa kali, jam berapa, hari apa.
 *
 * Diekspor supaya bisa diuji langsung — di dalam `BagianScraping` nilainya dipasang
 * `useEffect`, yang tidak dijalankan renderToString (XXIII-1), jadi menguji lewat
 * halamannya hanya pernah menguji keadaan kosongnya.
 */
export function Ringkas({ jadwal, t }) {
  const terurai = dariCron(jadwal)
  // Cron bebas (ditulis tangan atau warisan) tidak bisa diringkas jadi "N× sehari" tanpa
  // berbohong. Dikatakan apa adanya — `Jadwal` di atas sudah memberi jalan keluarnya.
  if (!terurai) return <Sub>{t('tk.frekuensiKosong')}</Sub>

  const { frekuensi, mulai, hari } = terurai
  const jam = jamDariFrekuensi(frekuensi, mulai)
  return (
    <KV>
      <KVBaris label={t('tk.frekuensiLabel')}>
        <b>{t('tk.frekuensiNilai', { n: frekuensi })}</b>{' '}
        <Sub>{t('tk.frekuensiTiap', { n: Math.floor(24 / frekuensi) })}</Sub>
      </KVBaris>
      <KVBaris label={t('tk.jamJalan')}>
        <span className="font-mono text-[12px]">
          {jam.map((h) => `${String(h).padStart(2, '0')}:00`).join(' · ')}
        </span>
      </KVBaris>
      <KVBaris label={t('tk.hariJalan')}>
        <span className="flex flex-wrap gap-1">
          {HARI_SINGKAT.map((label, i) => (
            <Chip key={label} nada={hari.includes(i + 1) ? 'ok' : 'idle'} titik={false}>
              {label}
            </Chip>
          ))}
        </span>
      </KVBaris>
    </KV>
  )
}

/**
 * PEMILIH TUJUAN satu slot — Instagram, Facebook, atau keduanya.
 *
 * MEDANNYA `platform`, BUKAN `id`. Kode ini pernah membaca `p.id`, yang selalu
 * `undefined` karena `/dashboard/tujuan` tidak mengembalikan medan bernama itu. Tiga
 * akibat sekaligus, dan tidak satu pun menghasilkan galat: tombolnya TIDAK PERNAH
 * menyala (`includes(undefined)` selalu false), menekannya menyisipkan `undefined` ke
 * daftar tujuan yang lalu tersimpan, dan `key` React kosong untuk semua baris.
 * `BuatKonten.jsx` memakai `platform` dengan benar sejak awal, jadi bedanya tidak
 * terlihat sampai ada yang mencoba memilih Facebook dari layar ini.
 *
 * Dipisah jadi komponen sendiri supaya bisa diuji tanpa halamannya: `BagianSlot` mengisi
 * daftarnya lewat `useEffect`, yang tidak dijalankan renderToString (XXIII-1).
 */
export function PilihTujuan({ t, tersedia, dipilih, set }) {
  // KOSONG BERARTI INSTAGRAM, bukan "semua". `automation.py` dulu mematok
  // platform='instagram'; slot yang tidak menyebut tujuan tetap jatuh ke sana, jadi slot
  // lama tidak berubah perilakunya.
  const kini = dipilih?.length ? dipilih : ['instagram']
  return (
    <span className="flex flex-wrap gap-1.5">
      {tersedia.map((p) => {
        const dipakai = kini.includes(p.platform)
        return (
          <Tombol
            key={p.platform}
            kecil
            aria-pressed={dipakai}
            jenis={dipakai ? 'utama' : 'sekunder'}
            // Tujuan yang belum siap tetap DITAMPILKAN, mati, dengan sebabnya. Tujuan
            // yang hilang dari layar terbaca sebagai fitur yang lenyap; yang mati dengan
            // sebab terbaca sebagai pekerjaan yang bisa diminta ke Smova.
            disabled={!p.siap}
            title={p.siap ? undefined : p.sebab}
            onClick={() => {
              const baru = dipakai
                ? kini.filter((x) => x !== p.platform)
                : [...kini, p.platform]
              // NOL TUJUAN tidak disimpan sebagai daftar kosong — kosong berarti "bawaan
              // Instagram" di backend, jadi mematikan yang terakhir akan diam-diam
              // menghidupkannya lagi. Yang terakhir tidak bisa dimatikan.
              set(baru.length ? baru : kini)
            }}
          >
            {p.label}
          </Tombol>
        )
      })}
      {tersedia.length === 0 && (
        <span className="text-[11.5px] text-ink3">{t('tk.tujuanKosong')}</span>
      )}
    </span>
  )
}

/**
 * SLOT TERBIT — satu slot = satu konten per hari.
 *
 * Jumlah konten per hari TIDAK diisi sendiri; ia turunan dari banyaknya slot
 * (`contents_per_day = len(publish_slots)` di backend). Menyediakan dua isian untuk satu
 * angka membuat keduanya bisa berselisih, dan yang mana yang menang jadi tebakan.
 */
function BagianSlot({ t, data, simpan, menyimpan, tujuanTersedia }) {
  const [slot, setSlot] = useState([])

  useEffect(() => {
    if (data) setSlot((data.publish_slots ?? []).map((s) => ({ ...s })))
  }, [data])

  const ubah = (i, k, v) => setSlot(slot.map((s, j) => (j === i ? { ...s, [k]: v } : s)))

  // GAMBAR PER HARI, bukan konten per hari — angka yang menentukan tagihan. Hitungannya
  // di `shared/lib/gambar.js` supaya bisa diuji tanpa merender halaman ini: daftar slotnya
  // diisi `useEffect`, yang tidak dijalankan renderToString.
  const gambarPerHari = hitungGambarPerHari(slot)
  const adaCollase = slot.some((x) => x.media_type !== 'video' && (Number(x.slide) || 1) > 1)

  useSimpanKepala(() => simpan({ publish_slots: slot }), { menyimpan })

  return (
    <>
    <Panel judul={t('tk.slotJudul')} catatan={t('tk.slotCatatan', { n: slot.length })}>
      {slot.length === 0 ? (
        <Body><p className="m-0 text-[12.5px] text-warn">{t('tk.slotKosong')}</p></Body>
      ) : (
        <Tabel kepala={[t('tk.kolJam'), t('tk.kolJenis'), t('tk.kolSlide'),
                        t('tk.kolTujuan'), '']}>
          {slot.map((s, i) => (
            <Baris key={i}>
              <td>
                <Isian
                  type="time"
                  className="max-w-[110px] font-mono"
                  value={s.time}
                  onChange={(e) => ubah(i, 'time', e.target.value)}
                />
              </td>
              <td>
                <Seg
                  nilai={s.media_type}
                  set={(v) => ubah(i, 'media_type', v)}
                  daftar={[
                    { id: 'photo', label: t('bk.foto') },
                    { id: 'video', label: t('bk.video') },
                  ]}
                />
              </td>
              {/* TUJUAN — kosong berarti Instagram saja, bukan "semua".
                  `automation.py` dulu mematok platform='instagram'; slot yang tidak
                  menyebut tujuan tetap jatuh ke sana, jadi slot lama tidak berubah
                  perilakunya. Satu baris antrean lahir PER tujuan, karena tiap platform
                  bisa gagal sendiri-sendiri. */}
              {/* SLIDE — collase hanya untuk foto. Slot video dikunci di 1 dan menyebut
                  sebabnya: Reels tidak punya bentuk carousel, dan backend menolak
                  kombinasinya. Isian yang bisa diketik lalu ditolak saat disimpan lebih
                  buruk daripada isian yang jelas tidak berlaku. */}
              <td>
                {s.media_type === 'video' ? (
                  <span className="text-[11.5px] text-ink3" title={t('tk.slideVideoKet')}>
                    {t('tk.slideVideo')}
                  </span>
                ) : (
                  <Isian
                    type="number"
                    min={1}
                    max={10}
                    className="max-w-[72px] tabular"
                    value={Number(s.slide) || 1}
                    onChange={(e) => ubah(i, 'slide', Math.max(1, Math.min(10,
                      Number(e.target.value) || 1)))}
                  />
                )}
              </td>
              <td>
                <PilihTujuan
                  t={t}
                  tersedia={tujuanTersedia}
                  dipilih={s.tujuan}
                  set={(v) => ubah(i, 'tujuan', v)}
                />
              </td>
              <td className="text-right">
                <Tombol kecil jenis="sekunder"
                        onClick={() => setSlot(slot.filter((_, j) => j !== i))}>
                  {t('ta.buang')}
                </Tombol>
              </td>
            </Baris>
          ))}
        </Tabel>
      )}

      <Body>
        <div>
          <Tombol
            kecil
            jenis="sekunder"
            onClick={() => setSlot([...slot,
              { time: '09:00', media_type: 'photo', slide: 1, tujuan: ['instagram'] }])}
          >
            {t('tk.slotTambah')}
          </Tombol>
        </div>
      </Body>

      {/* Catatan ini ikut turun bersama tombol simpannya yang lama, dan ia harus tetap
          ada: jumlah konten per hari TURUNAN dari banyaknya slot, bukan isian sendiri. */}
      <Body className="border-t border-line">
        <Sub>{t('tk.slotSimpanCatatan')}</Sub>
        {/* ANGKA YANG MENENTUKAN TAGIHAN, dan ia berubah saat slide dinaikkan — di situ
            gunanya. "4 konten per hari" tidak berubah saat satu slot jadi 3 slide,
            padahal belanjanya naik dua kali lipat. */}
        <Sub>{t('tk.gambarPerHari', { n: gambarPerHari })}</Sub>
      </Body>
    </Panel>

    {adaCollase && (
      <Bendera nada="warn" judul={t('tk.collaseBiayaJudul')} className="max-w-[80ch]">
        {t('tk.collaseBiayaIsi', { n: gambarPerHari })}
      </Bendera>
    )}
    </>
  )
}

/**
 * RANTAI OTOMATIS — empat langkah, empat saklar, dalam urutan jalannya.
 *
 * Sebelumnya tab ini menampilkan dua gerbang persetujuan SAJA, dibaca saja, dengan
 * catatan "diatur di layar Fitur". Dua hal salah di sana sekaligus:
 *
 *   1. Keduanya bukan yang Seleris JUAL, melainkan keputusan klien — "saya mau meninjau
 *      konsep dulu atau tidak". Mengunci itu ke operator membuat klien menelepon untuk
 *      sesuatu yang seharusnya satu klik. (ADR-068)
 *   2. Dua langkah pertama rantai — cari bahan, susun konsep — tidak ada di layar mana
 *      pun padahal saklarnya sudah dibaca n8n sejak lama. Klien yang ingin menghentikan
 *      belanja model untuk sementara tidak punya satu pun tombol.
 *
 * URUTANNYA YANG MEMBUATNYA BISA DICERNA. Ini satu rantai: mematikan langkah 1 membuat
 * 2–4 menganggur, dan itu tidak terlihat dari empat saklar yang berdiri sendiri-sendiri.
 *
 * DUA JENIS "MATI", DAN BEDANYA PENTING:
 *   langkah 1–2 mati  ->  TIDAK TERJADI apa-apa
 *   langkah 3–4 mati  ->  terjadi, lalu MENUNGGU orang menyetujui
 * Menyamakan keduanya jadi "mati" membuat orang mengira konten berhenti padahal ia
 * menumpuk di antrean persetujuan.
 */
const LANGKAH = [
  { medan: 'automate_scraping', kunci: 'cariBahan', fitur: 'scraping', jenis: 'jalan' },
  { medan: 'automate_drafting', kunci: 'susunKonsep', fitur: 'drafting', jenis: 'jalan' },
  { medan: 'automate_concept', kunci: 'setujuiKonsep', fitur: 'drafting', jenis: 'gerbang' },
  { medan: 'automate_uploading', kunci: 'setujuiAset', fitur: 'drafting', jenis: 'gerbang' },
]

// LANGKAH 4 KEMBALI 21 September (ADR-078), sesudah dicabut 16 September.
//
// Alasan pencabutannya benar pada waktunya: ADR-071 membuat rantai otomatis berhenti di
// DRAF, gambarnya dipilih orang di Smova, dan menyuruh orang menyetujui gambar yang baru
// saja ia pilih sendiri adalah gerbang yang tidak menjaga apa pun. Satu-satunya pembacanya
// waktu itu `factory._sambung_ke_antrean`, yang ikut tercabut bersama 04a/04b.
//
// ADR-078 membalik premisnya: rantainya sekarang MEMBUAT gambarnya sendiri, dan
// `auto_approve_asset` dibaca `AutomationService.pasang_gambar` — dua jalur sekaligus,
// terjadwal dan "Setujui konsep". Jadi ada lagi gambar yang dibuat mesin untuk diperiksa
// orang, dan saklarnya menahan sesuatu yang nyata.
//
// Saklarnya memang tidak pernah hilang dari API maupun `tenant_features`
// (`automate_uploading` <-> `auto_approve_asset` di `web/v1/settings.py`) — yang hilang
// lima hari cuma tombolnya di layar ini.

export function Rantai({ t, data, nyala, simpan, menyimpan }) {
  return (
    <>
      <Panel judul={t('tk.rantaiJudul')} catatan={t('tk.rantaiCatatan')}>
        <Body className="flex flex-col gap-2.5">
          {LANGKAH.map((l, i) => {
            const aktif = Boolean(data?.[l.medan])
            // FITUR DASARNYA MATI = saklar ini tidak berarti apa-apa. Ditampilkan dan
            // DIMATIKAN dengan sebabnya, bukan disembunyikan: saklar yang lenyap terbaca
            // sebagai kemampuan yang hilang, dan yang mati dengan sebab terbaca sebagai
            // sesuatu yang bisa diminta ke Smova.
            const bisa = nyala[l.fitur] !== false
            return (
              <div
                key={l.medan}
                className="flex flex-wrap items-center gap-3 bg-surface2 border
                           border-line rounded-md px-3 py-2.5"
              >
                <span className="w-5 shrink-0 text-[11px] tabular font-semibold text-ink3">
                  {i + 1}
                </span>
                <span className="flex-1 min-w-[180px]">
                  <b className="block text-[13px]">{t(`tk.langkah.${l.kunci}`)}</b>
                  <span className="block text-[11.5px] text-ink2">
                    {bisa
                      ? t(aktif ? `tk.langkahOn.${l.kunci}` : `tk.langkahOff.${l.kunci}`)
                      : t('tk.langkahTakDibeli', { fitur: t(`tk.fiturNama.${l.fitur}`) })}
                  </span>
                </span>
                <Seg
                  nilai={aktif ? 'ya' : 'tidak'}
                  set={(v) => simpan({ [l.medan]: v === 'ya' })}
                  daftar={[
                    { id: 'ya', label: t('tk.otomatis') },
                    { id: 'tidak', label: t(l.jenis === 'jalan' ? 'tk.mati' : 'tk.tinjauDulu') },
                  ]}
                  className={(!bisa || menyimpan) ? 'pointer-events-none opacity-45' : undefined}
                />
              </div>
            )
          })}
        </Body>
      </Panel>

      <Bendera nada="info" judul={t('tk.rantaiBedaJudul')} className="max-w-[80ch]">
        {t('tk.rantaiBedaIsi')}
      </Bendera>

      <Sub className="block max-w-[80ch]">{t('tk.videoMasihManual')}</Sub>
    </>
  )
}

export default function Konten() {
  const tujuan = useTujuan()
  const { t } = useBahasa()
  const [tab, setTab] = useState('bahan')
  const fitur = useFiturTenant()
  const setelan = useSetelanSaya()
  const ubah = useUbahSetelanSaya()

  if (fitur.isLoading || setelan.isLoading) return <Memuat tinggi={6} />
  if (fitur.isError) return <Gagal galat={fitur.error} ulangi={fitur.refetch} />
  if (setelan.isError) return <Gagal galat={setelan.error} ulangi={setelan.refetch} />

  const nyala = Object.fromEntries((fitur.data ?? []).map((f) => [f.key, f.enabled]))

  return (
    <PenyediaSimpan>
      <KepalaHalaman
        judul={t('tk.judul')}
        keterangan={t('tk.keterangan')}
        aksi={<TombolSimpanKepala t={t} />}
      />

      <Tab
        aktif={tab}
        set={setTab}
        daftar={[
          { id: 'bahan', label: t('tk.tabBahan') },
          { id: 'slot', label: t('tk.tabSlot') },
          { id: 'gerbang', label: t('tk.tabGerbang') },
          { id: 'model', label: t('tk.tabModel') },
          { id: 'referensi', label: t('tk.tabReferensi') },
        ]}
      />

      {ubah.isError && <Bendera nada="bad" role="alert">{ubah.error?.message}</Bendera>}

      {tab === 'bahan' && (
        nyala.scraping ? (
          <BagianScraping
            t={t}
            data={setelan.data}
            simpan={(body) => ubah.mutate(body)}
            menyimpan={ubah.isPending}
          />
        ) : (
          <Bendera nada="info" className="max-w-[76ch]">{t('tk.scrapingMati')}</Bendera>
        )
      )}

      {tab === 'slot' && (
        <BagianSlot
          t={t}
          data={setelan.data}
          simpan={(body) => ubah.mutate(body)}
          menyimpan={ubah.isPending}
          tujuanTersedia={tujuan.data ?? []}
        />
      )}

      {tab === 'gerbang' && (
        <Rantai
          t={t}
          data={setelan.data}
          nyala={nyala}
          simpan={(body) => ubah.mutate(body)}
          menyimpan={ubah.isPending}
        />
      )}

      {/* GAMBAR DAN PROMPT UNTUK AI, SATU TAB (ADR-081). Dua tab sebelumnya — "Referensi
          gambar" dan "Referensi prompt" — adalah dua setengah dari satu alur, dan yang satu
          tidak berarti tanpa yang lain. */}
      {tab === 'referensi' && <Referensi />}


      {tab === 'model' && (
        <Model
          peran={['text', 'image', 'video']}
          catatan={
            <Bendera nada="info" judul={t('tk.modelBiayaJudul')}>
              <p>{t('tk.modelBiayaIsi')}</p>
            </Bendera>
          }
        />
      )}
    </PenyediaSimpan>
  )
}
